import React, { useCallback, useEffect, useState, useTransition } from "react";
import classNames from "classnames/bind";
import {
  Button,
  Loading,
  HeaderModal,
  Row,
  Col,
  InputTextBox,
  SelectBox,
  SelectBoxItem,
  Toast,
} from "../../../components";
import useFetchData from "../../../hooks/useFetchData";
import { isValidatorUrl } from "../../../utils";
import { cameraManagement } from "../../../services/api/cameraManagementApi";
import styles from "./Camera.module.css";
import { recordApi } from "../../../services/api/RecordApi";
import { typeCamera as listTypeCameraSetting } from "../../../services/api/typeCamera";
import { useTranslation } from "react-i18next";
const cx = classNames.bind(styles);
const ModalInfo = ({
  show,
  camera,
  onClose,
  openSetting,
  loading,
  isSetting,
  isRefresh,
  setIsRefresh,
}) => {
  const refModal = React.useRef(null);
  const [address, setAddress] = useState("");
  const [rtsp, setRtsp] = useState("");
  const [name, setName] = useState("");
  const [wareHouseCode, setWareHouseCode] = useState();
  const [isUpdate, setIsUpdate] = useState(false);
  const [resolution, setResolution] = useState();
  const [frameRate, setFrameRate] = useState("1000");
  const [videoEncoding, setVideoEncoding] = useState("h264");
  const [quality, setQuality] = useState({ width: "960", height: "1080" });
  const [maxBitRate, setMaxBitRate] = useState("1000");
  const [typeCamera, setTypeCamera] = useState();
  const [typeSetting, setTypeSetting] = useState();
  const [companyName, setCompanyName] = useState();
  const [qualityVideo, setQualityVideo] = useState();
  const [recordQuality, setRecordQuality] = useState();
  const [subQuality, setSubQuality] = useState();
  const [listTypeCam, setListTypeCamera] = useState([])
  const groups = useFetchData(`/warehouse/get-list-warehouse/?nation_code=VNM`);
  const lreso = useFetchData("/videoQuality/get-list-video-quality/");
  const [label, setLabel] = useState();
  const [isDefault, setIsDefault] = useState(false);
  const { t } = useTranslation()
  const handleUpdate = () => {
    if (isUpdate) {
      async function changeInfoCamera() {
        try {
          const res = await cameraManagement.update(
            {
              camera_name: name,
              warehouse_code: wareHouseCode,
              rtsp_chinh: rtsp,
              width: quality.width,
              height: quality.height,
              frame_rate: frameRate,
              max_bitrate: maxBitRate,
              video_encoding: videoEncoding,
              type_camera: typeCamera,
              type_setup: typeSetting,
            },
            camera[0].CODE
          );
          Toast.open(t("infoCamera.updateSuccess"), "success");
          setIsRefresh(!isRefresh);
          setIsUpdate(!isUpdate);
          onClose();
          return res;
        } catch (e) {
          setIsUpdate(!isUpdate);
          Toast.open(t("infoCamera.updateError"), "danger");
        }
      }
      changeInfoCamera();
    }
    setIsUpdate(!isUpdate);
  };

  const getListStatus = useCallback(async (code) => {
    try {
      const data = [code];
      const res = await cameraManagement.postStatus({
        list_camera_code: data,
      })
      setIsRefresh(!isRefresh)
      return res.result;
    } catch (e) { }
  }, [])

  const handleOpen = () => {
    openSetting();
  };
  const handleClose = () => {
    setIsUpdate(!isUpdate);
    onClose();
  };
  const onChangeReso = (data) => {
    setResolution(data);
  };
  const onChangeNameCamera = (data) => {
    setName(data);
  };
  const onChangeRtsp = (data) => {
    setRtsp(data);
  };
  const onChangeWareHoues = (data, label) => {
    setWareHouseCode(data);
    setLabel(label);
  };
  React.useEffect(() => {
    const handleClickOutSide = (e) => {
      if (e.target === refModal.current) {
        onClose();
      }
    };
    document.body.addEventListener("click", handleClickOutSide);
    return () => {
      document.body.addEventListener("click", handleClickOutSide);
    };
    // eslint-disable-next-line
  }, []);
  React.useEffect(() => {
    if (camera && camera.length > 0) {
      setAddress(
        camera[0].COMMUNE_NAME +
        " - " +
        camera[0].DISTRICT_NAME +
        " - " +
        camera[0].PROVINCE_NAME
      );
      setName(camera[0].NAME_CAM);
      setRtsp(camera[0].RTSP_CHINH);
      setWareHouseCode(camera[0].WAREHOUSE_CODE);
      setLabel(camera[0].WAREHOUSE_NAME);
      setResolution(camera[0].MAIN_SOURCE);
      setQuality({ width: camera[0].WIDTH, height: camera[0].HEIGHT });
      setFrameRate(camera[0].FRAME_RATE);
      setMaxBitRate(camera[0].MAX_BITRATE);
      setVideoEncoding(camera[0].STREAM_MODE);
      setTypeCamera(camera[0].CAMERA_TYPE_CODE);
      setCompanyName(camera[0].COMPANY_NAME);
      setTypeSetting(camera[0].TYPE_SETUP);
      setQualityVideo(camera[0].QUALITY);
      setSubQuality(camera[0].SUB_SOURCE);
      if (camera[0].STATUS === "Lose" && show) {
        Toast.open(t("infoCamera.needRestart"), "danger");
      }
    }
    setIsUpdate(false);
  }, [camera, show, isDefault]);

  useEffect(() => {
    const getRecordQuality = async () => {
      try {
        const codeCam = camera[0].CODE
        let params = {
          camera_code: codeCam,
        };
        const recordRate = await recordApi.getRecordQualityConfig(params);
        setRecordQuality(recordRate.quality)
      } catch (error) {
        // // console.log(error);
      }
    }
    getRecordQuality()
  }, [camera[0]?.CODE])

  useEffect(() => {
    const getListTypeCam = async () => {
      try {
        const types = await listTypeCameraSetting.get();
        if (types && types?.data) {
          const listTypeCam = types?.data?.map((item) => {
            return {
              CODE: item?.CODE,
              NAME: item?.SUBJECT_NAME
            }
          })
          setListTypeCamera(listTypeCam);
        }
      } catch (error) {
        // // console.log(error);
      }
    }
    getListTypeCam();
  }, [])
  const handleRestartCamera = async (code) => {
    try {
      cameraManagement.restartStream({
        camera_id: code,
      });
      setTimeout(() => {
        Toast.open(t("infoCamera.restartSuccess"), "success");
        setIsRefresh(!isRefresh);
      }, 2000);
      setTimeout(() => {
        getListStatus(code)
      }, 30 * 1000);
    } catch (error) {
      Toast.open(t("infoCamera.restartAfterMinutes"), "danger");
    }
  };

  const onChangeFrameRate = (data) => {
    setFrameRate(data);
  };
  const onChangeQualityWidth = (data) => {
    setQuality((prev) => ({ ...prev, width: data }));
  };
  const onChangeQualityHeight = (data) => {
    setQuality((prev) => ({ ...prev, height: data }));
  };
  const onChangeVideoEncoding = (data) => {
    setVideoEncoding(data);
  };
  const onChangeMaxBitRate = (data) => {
    setMaxBitRate(data);
  };
  const onChangeTypeCamera = (data) => {
    setTypeCamera(data);
  };
  const onChangeTypeSetting = (data) => {
    setTypeSetting(data);
  };

  return (
    <>
      {show && (
        <div className={cx("modal-info")} ref={refModal}>
          <div className={cx("container")}>
            {!loading ? (
              <>
                <HeaderModal
                  title={camera.length > 0 && camera[0].NAME_CAM}
                  onClose={handleClose}
                />
                <div className={cx("data-info")}>
                  <Row gap={[0, 30]}>
                    <Col span={6}>
                      <InputTextBox
                        style={{ marginBottom: 16 }}
                        type="text"
                        placeholder={t("infoCamera.type")}
                        title={t("infoCamera.cameraName")}
                        disabled={!isUpdate}
                        onChange={onChangeNameCamera}
                        value={name}
                      />

                      <InputTextBox
                        style={{ marginBottom: 16 }}
                        type="text"
                        placeholder={t("infoCamera.type")}
                        title={t("infoCamera.brandName")}
                        onChange={onChangeTypeCamera}
                        disabled={!isUpdate}
                        value={listTypeCam.find(item => item.CODE === typeCamera)?.NAME}
                      />
                      <InputTextBox
                        style={{ marginBottom: 16 }}
                        type="text"
                        placeholder={t("infoCamera.type")}
                        title={t("infoCamera.typeSetup")}
                        onChange={onChangeTypeSetting}
                        disabled={!isUpdate}
                        value={typeSetting}
                      />
                      <SelectBox
                        style={{ marginBottom: 18 }}
                        type="small"
                        required
                        title={t("infoCamera.warehouse")}
                        select
                        onChange={onChangeWareHoues}
                        values={label}
                        disabled={isUpdate}
                      >
                        {groups?.data.data &&
                          groups?.data.data.map((item, index) => (
                            <SelectBoxItem
                              label={item.WAREHOUSE_NAME}
                              value={item.CODE}
                              key={index}
                            />
                          ))}
                      </SelectBox>
                      <InputTextBox
                        style={{ marginBottom: 16 }}
                        type="text"
                        placeholder={t("infoCamera.type")}
                        title={t("infoCamera.companyName")}
                        // onChange={onChangeTypeSetting}
                        disabled={true}
                        value={companyName}
                      />
                      {isSetting && (
                        <InputTextBox
                          style={{ marginBottom: 16, marginTop: -4 }}
                          type="text"
                          placeholder={t("infoCamera.type")}
                          title={t("infoCamera.address")}
                          value={address}
                          disabled={true}
                        />
                      )}
                      <SelectBox
                        style={{ marginBottom: 16.5, marginTop: -2 }}
                        type="small"
                        required
                        title={t("infoCamera.resolution")}
                        select
                        onChange={onChangeReso}
                        disabled={isUpdate}
                        values={resolution}
                      >
                        {lreso?.data &&
                          lreso?.data.map((item, index) => (
                            <SelectBoxItem
                              label={item.QUALITY}
                              value={item.QUALITY}
                              key={index}
                            />
                          ))}
                      </SelectBox>

                    </Col>
                    <Col span={6}>
                      <SelectBox
                        style={{ marginBottom: 16.5, marginTop: -2 }}
                        type="small"
                        required
                        title={t("infoCamera.resolutionPlayback")}
                        select
                        onChange={onChangeReso}
                        disabled={isUpdate}
                        values={recordQuality ? recordQuality : t("infoCamera.cameraIsOff")}
                      >
                        {lreso?.data &&
                          lreso?.data.map((item, index) => (
                            <SelectBoxItem
                              label={item.QUALITY}
                              value={item.QUALITY}
                              key={index}
                            />
                          ))}
                      </SelectBox>
                      {isSetting ? (
                        <InputTextBox
                          style={{ marginBottom: 16 }}
                          type="text"
                          placeholder={t("infoCamera.type")}
                          title={t("infoCamera.rtsp")}
                          onChange={onChangeRtsp}
                          value={rtsp}
                          disabled={!isUpdate}
                          error={isValidatorUrl(rtsp) ? false : true}
                          titleError={t("infoCamera.rtpsEmpty")}
                        />
                      ) : (
                        <InputTextBox
                          style={{ marginBottom: 16 }}
                          type="text"
                          placeholder={t("infoCamera.type")}
                          title={t("infoCamera.address")}
                          value={address}
                          disabled={true}
                        />
                      )}
                      <InputTextBox
                        style={{ marginBottom: 16 }}
                        type="text"
                        placeholder={t("infoCamera.width")}
                        title={t("infoCamera.width")}
                        onChange={onChangeQualityWidth}
                        value={quality.width}
                        disabled={!isUpdate}
                        error={isValidatorUrl(rtsp) ? false : true}
                        titleError={t("infoCamera.rtpsEmpty")}
                      />
                      <InputTextBox
                        style={{ marginBottom: 18 }}
                        type="text"
                        placeholder={t("infoCamera.height")}
                        title={t("infoCamera.height")}
                        onChange={onChangeQualityHeight}
                        value={quality.height}
                        disabled={!isUpdate}
                        error={isValidatorUrl(rtsp) ? false : true}
                        titleError={t("infoCamera.rtpsEmpty")}
                      />
                      <SelectBox
                        style={{ marginBottom: 16.5, marginTop: -2 }}
                        type="small"
                        required
                        title={t("infoCamera.subResolution")}
                        select
                        onChange={onChangeReso}
                        disabled={isUpdate}
                        values={subQuality ? subQuality : t("infoCamera.subResolutionEmty")}
                      >
                        {lreso?.data &&
                          lreso?.data.map((item, index) => (
                            <SelectBoxItem
                              label={item.QUALITY}
                              value={item.QUALITY}
                              key={index}
                            />
                          ))}
                      </SelectBox>
                      {/* <InputTextBox
                        style={{ marginBottom: 16 }}
                        type="text"
                        placeholder="Tỷ lệ khung hình"
                        title="Tỷ lệ khung hình *"
                        onChange={onChangeFrameRate}
                        value={frameRate}
                        disabled={!isUpdate}
                        error={isValidatorUrl(rtsp) ? false : true}
                        titleError={"Vui lòng nhập đúng đường dẫn rtsp"}
                      /> */}
                      {/* <InputTextBox
                        style={{ marginBottom: 16 }}
                        type="text"
                        placeholder="Tốc độ bit tối đa"
                        title="Tốc độ bit tối đa *"
                        onChange={onChangeMaxBitRate}
                        value={maxBitRate}
                        disabled={!isUpdate}
                        error={isValidatorUrl(rtsp) ? false : true}
                        titleError={"Vui lòng nhập đúng đường dẫn rtsp"}
                      /> */}
                      <InputTextBox
                        style={{ marginBottom: 16 }}
                        type="text"
                        placeholder={t("infoCamera.videoDecode")}
                        title={`${t("infoCamera.videoDecode")}`}
                        onChange={onChangeVideoEncoding}
                        value={videoEncoding}
                        disabled={!isUpdate}
                        error={isValidatorUrl(rtsp) ? false : true}
                        titleError={t("infoCamera.rtpsEmpty")}
                      />
                    </Col>
                    <Col span={12}></Col>
                  </Row>
                </div>
                {isSetting && (
                  <div className={cx("actions")}>
                    <Button
                      onClick={handleUpdate}
                      className={cx("btn-setting")}
                      title={isUpdate ? t("infoCamera.accept") : t("infoCamera.edit")}
                    />
                    {isUpdate ? (
                      <Button
                        // onClick={h}
                        className={cx("btn-close")}
                        title={t("infoCamera.cancel")}
                        onClick={() => {
                          setIsDefault(!isDefault);
                        }}
                      />
                    ) : (
                      <Button
                        onClick={handleOpen}
                        className={cx("btn-setting")}
                        title={t("infoCamera.settingCamera")}
                      />
                    )}
                    {camera[0].STATUS !== "Off" && (
                      <Button
                        onClick={() => handleRestartCamera(camera[0].CODE)}
                        title={t("infoCamera.restart")}
                        className={cx("btn-setting")}
                      />
                    )}
                  </div>
                )}
              </>
            ) : (
              <div className={cx("loading")}>
                <Loading />
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ModalInfo;
